import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedModule } from '../shared.module';
import { LeadOwnerSearchRoutingModule } from './lead-owner-search-routing.module';
import { LeadOwnerSearchComponent } from './lead-owner-search.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomFlexLayoutModule } from '../flex-layout/custom-flex-layout.module';
import { DirectiveModule } from '../directive/directive.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
  declarations: [
    LeadOwnerSearchComponent
  ],
  imports: [
    CommonModule,
    LeadOwnerSearchRoutingModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    SharedModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    MatButtonModule,
    CustomFlexLayoutModule,
    DirectiveModule,
    MatProgressSpinnerModule
  ],
  exports: [
    LeadOwnerSearchComponent
  ]
})
export class LeadOwnerSearchModule { }
